import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-validators',
  templateUrl: './list-validators.component.html',
  styleUrls: ['./list-validators.component.css']
})
export class ListValidatorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
